var map = {
	"./bonus_symbol_0.png": "ec31",
	"./bonus_symbol_1.png": "e2e5",
	"./bonus_symbol_2.png": "af19",
	"./bonus_symbol_3.png": "556c",
	"./bonus_symbol_4.png": "3abb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7f84";